var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_67","data-name":"Path 67","d":"M13.451,29.5h5.422V18.646h4.885l.537-5.394H18.872V10.527a1.355,1.355,0,0,1,1.355-1.355h4.066V3.75H20.227a6.777,6.777,0,0,0-6.777,6.777v2.724H10.74L10.2,18.646h3.248Z","transform":"translate(-10.203 -3.75)"}));
}

Facebook.defaultProps = {"id":"facebook","width":"14.091","height":"25.752","viewBox":"0 0 14.091 25.752"};

module.exports = Facebook;

Facebook.default = Facebook;
